import _toConsumableArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { isString } from 'lodash';
import { getLocalTranslation } from './i18nKit';
export var UncertaintyNameTextEnum;

(function (UncertaintyNameTextEnum) {
  UncertaintyNameTextEnum["supplierParentAndSubsidiary"] = "supplierParentAndSubsidiary";
  UncertaintyNameTextEnum["supplierParentAndSubsidiarySingle"] = "supplierParentAndSubsidiarySingle";
  UncertaintyNameTextEnum["supplierClientCompanies"] = "supplierClientCompanies";
  UncertaintyNameTextEnum["supplierClientCompaniesSingle"] = "supplierClientCompaniesSingle";
  UncertaintyNameTextEnum["supplierName"] = "supplierName";
  UncertaintyNameTextEnum["supplierNameSingle"] = "supplierNameSingle";
  UncertaintyNameTextEnum["supplierOwnSubsidiary"] = "supplierOwnSubsidiary";
  UncertaintyNameTextEnum["supplierOwnSubsidiarySingle"] = "supplierOwnSubsidiarySingle";
})(UncertaintyNameTextEnum || (UncertaintyNameTextEnum = {}));

export var getUncertaintyNameText = function getUncertaintyNameText(uncertaintyName) {
  var text = '';

  switch (uncertaintyName) {
    case UncertaintyNameTextEnum.supplierParentAndSubsidiary:
      text = 'MSP legal entities';
      break;

    case UncertaintyNameTextEnum.supplierParentAndSubsidiarySingle:
      text = 'MSP legal entity';
      break;

    case UncertaintyNameTextEnum.supplierClientCompanies:
      text = 'Client companies';
      break;

    case UncertaintyNameTextEnum.supplierClientCompaniesSingle:
      text = 'Client company';
      break;

    case UncertaintyNameTextEnum.supplierName:
      text = 'Suppliers';
      break;

    case UncertaintyNameTextEnum.supplierNameSingle:
      text = 'Supplier';
      break;

    case UncertaintyNameTextEnum.supplierOwnSubsidiary:
      text = 'Supplier legal entities';
      break;

    case UncertaintyNameTextEnum.supplierOwnSubsidiarySingle:
      text = 'Supplier legal entity';
      break;

    default:
      break;
  }

  return text;
};
export var trimText = function trimText(value) {
  if (!isString(value)) {
    return '';
  }

  return value.trim();
};
export var appendOptionText = function appendOptionText(text) {
  if (!text) {
    return text;
  }

  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return "".concat(text, " (").concat($t('kit:optional'), ")");
}; // normalize text for case/accent-insensitive fuzzy comparison

var normalizeFuzzyText = function normalizeFuzzyText(text) {
  return (text || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
/**
 * Create a fuzzy filter compatible with MUI Autocomplete's `filterOptions` prop.
 * - splits the input by whitespace into tokens; every token must appear as a substring of the searchable text (anywhere, not contiguous)
 * - sorts by relevance: matches at the string start or a word boundary rank higher, and earlier tokens weigh more
 * @param matchConfig controls which text of an option is searched:
 *  - `undefined`: match the default `label` field only
 *  - `string[]`: extra field keys matched IN ADDITION to `label` (e.g. `['description']` searches label + description)
 *  - `function`: a custom getter returning the full searchable text (overrides the default label matching)
 */


export var createFuzzyOptionsFilter = function createFuzzyOptionsFilter(matchConfig) {
  return function (options, state) {
    // resolve the searchable text of a single option based on matchConfig
    var getOptionText = function getOptionText(option) {
      var _matchConfig;

      if (typeof matchConfig === 'function') return (_matchConfig = matchConfig(option)) !== null && _matchConfig !== void 0 ? _matchConfig : '';
      var fields = ['label'].concat(_toConsumableArray(matchConfig !== null && matchConfig !== void 0 ? matchConfig : []));
      return fields.map(function (field) {
        return option === null || option === void 0 ? void 0 : option[field];
      }).filter(Boolean).join(' ');
    };

    var input = normalizeFuzzyText(((state === null || state === void 0 ? void 0 : state.inputValue) || '').trim());
    if (!input) return options;
    var tokens = input.split(/\s+/).filter(Boolean);
    return options.map(function (option) {
      var text = normalizeFuzzyText(getOptionText(option));
      var positions = tokens.map(function (token) {
        return text.indexOf(token);
      }); // all tokens must be present

      if (positions.some(function (position) {
        return position === -1;
      })) return null;
      var score = 0;
      positions.forEach(function (position, index) {
        var weight = index === 0 ? 2 : 1;
        score += position * weight; // boost when the token matches at the string start or right after a non-alphanumeric char (word boundary)

        var isWordStart = position === 0 || /[^a-z0-9]/.test(text[position - 1]);
        if (isWordStart) score -= 50 * weight;
      });
      return {
        option: option,
        score: score
      };
    }).filter(function (item) {
      return item !== null;
    }).sort(function (a, b) {
      return a.score - b.score;
    }).map(function (item) {
      return item.option;
    });
  };
};